module.exports = __webpack_public_path__ + "static/media/basel-21.02dc68cb.jpg";